import { Component, input } from '@angular/core';
import { RewardPipe, TemplateRewardPipe } from '@shared/pipes';

@Component({
  selector: 'b2c-reward-sticker',
  styleUrl: './reward-sticker.component.scss',
  templateUrl: './reward-sticker.component.html',
  imports: [RewardPipe, TemplateRewardPipe],
})
export class RewardStickerComponent {
  imageUrl = input.required<string>();
  alternativeText = input.required<string>();
  amount = input<number>(0);
  amountColor = input<string>('');
  amountFontFamily = input<string>('');
  /** Replaces the amount, e.g. once the step's reward is credited. */
  checkIconUrl = input<string>();
}
